import { useEffect } from "react";
import { computeSeo } from "../seo/computeSeo";
import { injectSeoTags } from "../seo/injectSeoTags";

/**
 * Per-route SEO. Delegates all "what to render" logic to computeSeo() (shared
 * with the prerender script) and all "how to inject" logic to injectSeoTags()
 * (client-side DOM manipulation with remove-then-inject strategy).
 *
 * We deliberately do NOT use react-helmet-async here. Helmet's tag dedup is
 * unreliable when the prerender step has already written matching tags into
 * the served HTML — you end up with duplicates. injectSeoTags() clears the
 * managed selectors first, then injects fresh ones with a data-seo-managed
 * marker, guaranteeing exactly one of each on every route.
 */
export default function SeoHead({
  title,
  description,
  nlPath,
  enPath,
  path,             // legacy alias for nlPath
  image,
  imageWidth,
  imageHeight,
  noindex = false,
  jsonLd,
  lang = "nl",
  ogType = "website",
}) {
  const resolvedNlPath = nlPath || path || "/";
  useEffect(() => {
    const seo = computeSeo({
      lang,
      nlPath: resolvedNlPath,
      enPath: enPath ?? null,
      title,
      description,
      image,
      imageWidth,
      imageHeight,
      ogType,
      jsonLd,
      noindex,
    });
    injectSeoTags(seo);
  }, [lang, resolvedNlPath, enPath, title, description, image, imageWidth, imageHeight, ogType, jsonLd, noindex]);

  return null;
}
